import { IAgoraRTCRemoteUser, ICameraVideoTrack, ILocalVideoTrack, IMicrophoneAudioTrack } from "agora-rtc-sdk-ng"
import { Layout } from "../../definitions"
import Basic from "./layouts/Basic"
import Spotlight from "./layouts/Spotlight"
import { useCallback } from "react"

export interface IBaseProps 
{
    users: IAgoraRTCRemoteUser[],
    userList: string[],
    tracks: [IMicrophoneAudioTrack, ICameraVideoTrack | undefined] | null,
    start: boolean,
    showVideo: boolean,
    myUsername: string,
}

export interface ILayoutVideosProps extends IBaseProps
{
    ownTrack: () => ILocalVideoTrack | undefined,
    getUsername: (user: string) => string,
    getCurrentUser: (username: string) => IAgoraRTCRemoteUser | undefined
}

export interface IVideosProps extends IBaseProps
{
    shareScreen?: boolean,
    screenTrack?: ILocalVideoTrack,
    layout: Layout
}

const MultiVideos = (props: IVideosProps) => {
    const {
        users,
        tracks,
        shareScreen,
        screenTrack
    } = props

    const ownTrack = useCallback(() => {
        if (shareScreen && screenTrack)
            return screenTrack;
        else if (tracks && tracks.length > 0)
            return tracks[1] as ILocalVideoTrack;
        else 
            return undefined
    }, [shareScreen, screenTrack, tracks]);
    
    const getUsername = (user: string) => {
        if(!user) return "Unknown user";

        return user || "Unknown user";
        //TODO Get username from API
    };

    const getCurrentUser = (username: string) => {
        const user = users.find(u => u.uid === username);
        return user;
    };

    const getProps = (): ILayoutVideosProps => {
        return {
            ...props,
            ownTrack,
            getUsername,
            getCurrentUser
        }
    }

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {props.layout === Layout.REGULAR ?
                <Basic {...getProps()} />
                :
                <Spotlight {...getProps()} />
            }
        </>
    )
}

export default MultiVideos
